import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Breadcrumb, BreadcrumbNav } from 'excellence-ui';

@Component({
  selector: 'app-parse-requests-details-breadcrumb-nav',
  imports: [BreadcrumbNav, Breadcrumb, RouterLink, NgIcon, TranslocoPipe],
  templateUrl: './parse-requests-details-breadcrumb-nav.html',
})
export class ParseRequestsDetailsBreadcrumbNav {
  organizationId = input.required<string>();
  parseRequestId = input.required<string>();
}
